import {Divider} from './Divider';
import './TopBar.scss';

export function TopBar() {
  return (
    <div className="topbar">
      <div className="header-content">
        <img src="/eni_logo.svg" alt="Logo" className="logo" />
      </div>
      <Divider />
    </div>
  );
}
